import tx from '@/utils/tx';

export function getBBSList(){
  return tx.get('/bbs/list');
}

export function getBBSDetail(bbsNo){
  return tx.get(`/bbs/detail/${bbsNo}`);
}
